import React, { useMemo } from 'react';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { ValidationGroup, Input } from '@bingads-webui-react/primitive-validation';
import { Constants, TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { InputTaxFieldId } from '../constants';
import { registerTaxform } from '../taxform-store';
import { validateField, CustomValidateItems } from '../validator';
import { withViewTaxFormWithFilledEmptyTaxValue, getTaxTypeLabel } from '../utils';
import { useValidationI18n } from '../hooks/use-i18n';

const { TaxLabelFormat, TaxType } = Constants;

export const AustraliaTaxSchema = {
  name: 'Australia Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.AUGSTNumber]: {
      type: 'string',
      maxLength: 50,
      required: false,
    },
  },
};

const AustraliaTaxForm = (props) => {
  const validationI18n = useValidationI18n(props.i18n);
  const taxTypeLabel = useMemo(() => getTaxTypeLabel(TaxType.AUGSTNumber, props.i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness }), [props.i18n]);
  const CustomizedFormGroup = props.showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;
  return (
    <ValidationGroup
      validationProps={{
        schema: AustraliaTaxSchema,
        i18n: validationI18n,
        onValidate: props.onValidate,
        data: props.data,
      }}
    >
      <CustomizedFormGroup
        isStatic
        label={taxTypeLabel}
      >
        <Input
          id={InputTaxFieldId(TaxType.AUGSTNumber)}
          validationProps={{
            field: TaxType.AUGSTNumber,
            alwaysShowError: props.alwaysShowError,
            validator: value => validateField(
              value,
              {},
              { [CustomValidateItems.AustraliaGSTNumberFormatValidation]: inputValue => !TaxUtils.isAUGSTNumberValid(inputValue) },
              props.i18n
            ),
          }}
          disabled={props.disabled}
        />
      </CustomizedFormGroup>
    </ValidationGroup>
  );
};

AustraliaTaxForm.propTypes = TaxTypeFormPropTypes;

registerTaxform('/AU/', AustraliaTaxForm, withViewTaxFormWithFilledEmptyTaxValue({ getTaxSchema: () => AustraliaTaxSchema }));
